const deviceId =
  'From Building. A unique identifier assigned to each BACnet device on the network for addressing and communication.';
const deviceName = 'From Building. The human-readable name assigned to the BACnet device.';
const deviceProtocol =
  'From Onboard Collector. The protocol used to collect data (e.g. BACnet, Modbus).';
const deviceModel = 'From Building. The manufacturer-assigned name or number for the device.';
const deviceVendor = 'From Building. The manufacturer or vendor of this device.';
const deviceDescription =
  'From Building. An optional field with extra details about the device, such as its function or location.';
const deploymentName =
  'From Onboard Collector. The name of the deployment associated with this building (e.g. Onboard/HQ).';

const confidence =
  'From Onboard AI. The percentage certainty of an AI-predicted label or relationship. Higher values indicate more reliable predictions.';

const equipmentName =
  'From Onboard AI. The name of the equipment associated with the devices. Must be unique from any Location Name. Editable by the user.';

const equipmentType =
  'From Onboard AI. A DBO semantic label categorizing an equipment by function. Editable by the user.';
const bacnetUnit =
  'From Building. The raw BACnet unit of measurement reported by the BACnet device for a point.';

export const tooltips = {
  published:
    'From Staging. Indicated whether a point or equipment is published to the live building model.',
  validation:
    'From Staging. Indicates whether a point or equipment is currently failing validation.',
  diff: 'From Staging. Indicates whether a point or equipment is different from its published version.',
  lastPublishedTime:
    'From Staging. The most recent time a point or equipment was published to the live building model.',
  firstDiscoveredTime:
    'From Onboard Collector. The timestamp when a point or device was first discovered.',
  lastDiscoveredTime:
    'From Onboard Collector. The timestamp when a point or device was most recently discovered.',

  deviceAddress: 'From Building. The IP address assigned to a device on the building network.',
  deploymentName,
  deploymentsName: deploymentName,

  deviceDescription,
  devicesDescription: deviceDescription,
  deviceId,
  devicesId: deviceId,
  deviceModel,
  devicesModel: deviceModel,
  deviceName,
  devicesName: deviceName,
  devicePointCount: 'From Building. The number of points discovered on a device.',
  devicesPrograms:
    'From Building. One or more control programs installed on the device. Multiple programs may indicate a gateway device.',
  deviceProtocol,
  devicesProtocol: deviceProtocol,
  devicesSoftware:
    'From Building. The firmware or software version currently installed on the device.',
  deviceVendor,
  devicesVendor: deviceVendor,

  activeInactive:
    'From Building. The two possible states of a binary object, Active (1) or Inactive (0).',
  alarmValue:
    'From Building. The threshold at which a binary object triggers an alarm, typically 0 (Inactive) or 1 (Active).',
  bacnetUnit,
  pointAssigned: 'From Staging. Indicates whether a point has been assigned to an equipment.',
  pointDescription:
    'From Building. An optional text field providing additional context about a sensor.',
  pointEquipNames: equipmentName,
  pointEquipTypes: equipmentType,
  pointName:
    'From Building. The name assigned to a point in the BAS, identifies the role of sensor or actuator.',
  pointObjectIdentifier:
    'From Building. A unique identifier for each object within a BACnet device.',
  pointTopic: 'From Onboard. A unique identifier for each point across the Onboard database',
  pointType:
    'From Onboard AI. A DBO semantic label categorizing a point by function. Editable by the user.',
  pointTypeConfidence: confidence,
  presentValue: 'From Building. The real-time value of the point captured during discovery.',
  protocolUnit: bacnetUnit,
  taggerPointUnassigned:
    'From Onboard AI. The point was deemed unimportant and was unassigned from its equipment.',
  units: 'From Onboard AI. The unit of measurement for a point, mapped to the QUDT standard.',

  equipmentName,
  equipmentType,
  equipmentTypeConfidence: confidence,
  equipmentRelationshipsTab: 'Equipment must be promoted to set relationships',
  devicesLocation:
    'From BACnet discovery. The physical location of the device as reported by the BACnet network.',
  devicesProfile:
    'From BACnet discovery. A shorthand identifier for describing a device and its interoperability capabilities. E.g. B-AAC (Advanced Application Controller) or B-SS (Smart Sensor)',
  equipmentFeedsConfidence: confidence,

  locationName:
    'User-defined. A descriptive name for a specific space within the building (e.g., Lobby East, 2nd Floor Corridor). Must be unique from any Equipment Name.',
  locationType: 'User-defined. A DBO semantic label for the type of space.',
  locationLocationCount: 'From Staging. The number of locations contained within each location.',
  locationEquipmentCount: 'From Staging. The number of equipment contained within each location.',
  locationCreatedTime: 'From Staging. The time when a location entity was created.',
};
